import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commentMention'
})
export class CommentMentionPipe implements PipeTransform {

  transform(commentMsg: any, commentMentionArray?: any): any {
    commentMentionArray.forEach((mentionsObj: any) => {
      commentMsg = commentMsg.replace(new RegExp('@' + mentionsObj.id, 'g'), `<span class="mention-text ${mentionsObj.id} ${mentionsObj.code}" id="${mentionsObj.id}">${'@' + mentionsObj.nickName}</span>`);
    });
    return commentMsg;
   // return `<span class="mention-text">*d</span>`;
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/comment-mention.pipe.ts